import { createSelector } from 'reselect';

export const getCreatedBluebeamSession = createSelector(
  (state) => state.pdfViewer.createdBluebeamSession,
  (errors) => {
    return errors;
  }
);
